import commonGetters from '@/store/data/common/getters'

const getters = {
    notReadyIsLoading: (state) => state.notReadyIsLoading
}

export default { ...commonGetters, ...getters }
